import { BASE_URL } from '@/constant'
import { prepareHeaders } from '@/lib/cookie'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export interface MilestoneUser {
  user_name: string
  duration_seconds: number
  billable_duration_seconds: number
  billable_employee_cost: number
  billable_project_cost: number
  total_employee_cost: number
  total_project_cost: number
  nonbillable_employee_cost: number
  overhead_cost?: number
  fully_loaded_cost?: number
}

export interface Milestone {
  milestone_id: string
  milestone_name: string
  users: MilestoneUser[]
}

export interface MilestoneResponse {
  success: boolean
  data: Milestone[]
}

export interface MilestoneTaskProgress {
  total: number
  completed: number
  remaining: number
  percentage: number
}

export interface MilestoneProgress {
  milestone_id: string
  milestone_name: string
  milestone_status: string
  is_completed: boolean
  tasks: MilestoneTaskProgress
}

export interface MilestoneProgressResponse {
  success: boolean
  data: {
    list_id: string
    milestones_summary: MilestoneTaskProgress
    milestones: MilestoneProgress[]
  }
}

export const milestoneAPi = createApi({
  reducerPath: 'milestonesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: prepareHeaders,
  }),
  endpoints: builder => ({
    getMilestones: builder.query({
      query: (id: number) => ({
        url: `/clickup-task/${id}`,
        method: 'GET',
      }),
    }),
    getMilestonesByListId: builder.query<MilestoneResponse, string>({
      query: (list_id: string) => ({
        url: `/projects/milestones/${list_id}`,
        method: 'GET',
      }),
    }),
    getMilestoneWiseProgress: builder.query<MilestoneProgressResponse, number>({
      query: (list_id: number) => ({
        url: `/clickup-task/projectmilstonewiseprogress/${list_id}`,
        method: 'GET',
      }),
    }),
  }),
})
export const {
  useGetMilestonesQuery,
  useGetMilestonesByListIdQuery,
  useGetMilestoneWiseProgressQuery,
} = milestoneAPi
